<template>
    <div>
        <vue-headful :title="(this.id ? 'Edit' : 'Create') + ' [Do Not Contact Code] - AMOS365'" />

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/admin/settings#codes">Settings</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page" v-if="!code.id">Create Do Not Contact Code</li>
                <li class="breadcrumb-item active" aria-current="page" v-else>Edit Do Not Contact Code</li>

            </ol>
        </nav>

        <h4 class="page-header">
            <span v-if="id">Edit: {{ code.dnc_code_reason }}</span>
            <span v-else>Create Do Not Contact Code</span>
        </h4>

        <div class="row">
            <div class="col-lg-8">
                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Details</strong>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.dnc_code_reason, 'text-muted-no': !errors.dnc_code_reason}">
                                Code Name: <i class="fa fa-asterisk text-danger fa-sm"></i>
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <input type="text" v-model="code.dnc_code_reason" :class="{'form-control': true, 'is-invalid': errors.dnc_code_reason}" placeholder="Enter Do Not Contact Code Name" />

                                <div class="text-danger mt-1" v-if="errors.dnc_code_reason">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.dnc_code_reason">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_active, 'text-muted-no': !errors.is_active}">
                                Active:
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <b-form-checkbox v-model="code.is_active" :value="1" :unchecked-value="0" plain />

                                <div class="text-danger mt-1" v-if="errors.is_active">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.is_active">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn-sm btn-success" v-on:click="postCode()" :disabled="saving">
                    <template v-if="saving"><i class="fa fa-spinner fa-spin"></i> Saving</template>
                    <template v-else>Save Do Not Contact Code</template>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                errors: {},
                code: {},
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {
            getCode(){
                //Send it
                this.$http.get('/admin/do-not-contact-codes' + (this.id ? '/'+this.id : ''))
                    .then(response => {
                        //Set Data
                        this.code = response.data.code;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            postCode(){
                //Set
                this.saving = true;

                //Send it
                this.$http.post('/admin/do-not-contact-codes', this.code)
                    .then(response => {
                        //Alert the user
                        this.$toastr.s('Do Not Contact Code Saved');

                        //Set Back to Settings
                        this.$router.push('/admin/settings#codes');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },
        },

        mounted() {
            //Get the Data
            this.getCode();
        }
    }
</script>